export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";